import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { getFirebase } from '../firebase/config';

export async function writeAudit(
  uid: string,
  email: string,
  action: string,
  detail = '',
): Promise<void> {
  const { db } = getFirebase();
  await addDoc(collection(db, 'auditLogs'), {
    uid,
    email,
    action,
    detail: detail.slice(0, 300),
    ts: serverTimestamp(),
  });
}
